import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import CountDown from '@/components/countdown/rushcountdown.vue';
import Price from '@/components/price/index.vue';
import { flashSaleList } from '@/services/http';
import { Mutation } from 'vuex-class';
import moment from 'moment';
import * as _ from 'lodash';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 未开始限时抢购
    _this.flashList = [];
    // 进行中限时抢购
    _this.flashIngList = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      document.querySelector('html').setAttribute('style', 'background-color:#f8f8fb;');
    }
  }, {
    key: "created",
    value: function created() {
      this.getFlashSaleList();
    }
    // 获取活动列表
  }, {
    key: "getFlashSaleList",
    value: function () {
      var _getFlashSaleList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var anchor, res, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              _context.next = 3;
              return flashSaleList({
                status: 0,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 3:
              res = _context.sent;
              _context.next = 6;
              return flashSaleList({
                status: 1,
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 6:
              response = _context.sent;
              if (res.data.data && res.data.data.length !== 0) {
                res.data.data.forEach(function (item) {
                  item.detailList.forEach(function (value) {
                    _this2.$set(value, 'discount_price', _.round(_.subtract(value.price, value.discount_fee), 2));
                  });
                });
              }
              if (response.data.data && response.data.data.length !== 0) {
                response.data.data.forEach(function (item) {
                  item.detailList.forEach(function (value) {
                    _this2.$set(value, 'discount_price', _.round(_.subtract(value.price, value.discount_fee), 2));
                  });
                });
              }
              this.flashList = res.data.data;
              this.flashIngList = response.data.data;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getFlashSaleList() {
        return _getFlashSaleList.apply(this, arguments);
      }
      return getFlashSaleList;
    }() // 到下单页面
  }, {
    key: "goOrder",
    value: function goOrder(list, status, id, buttonnum) {
      if (status === 1 && buttonnum !== 0) {
        var confirmlist = [{
          panicBuyId: id,
          limit_num: list.limit_num,
          productId: list.product_id,
          mallImage: {
            source_url: list.source_url,
            product_name: list.product_name
          },
          natureList: [],
          nature_value: list.nature_value,
          num: 1,
          id: list.price_id,
          price: list.discount_price,
          totalPrice: list.discount_price
        }];
        this.CONFIRMORDER(confirmlist);
        this.$router.push('/orderconfirm?type=2&from=flashsale');
      }
    }
  }]);
}(Vue);
__decorate([Mutation('order/CONFIRMORDER')], default_1.prototype, "CONFIRMORDER", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop,
    CountDown: CountDown,
    Price: Price
  },
  filters: {
    formatDate: function formatDate(time) {
      return moment(time).format('MM月DD日 HH:mm');
    }
  }
})], default_1);
export default default_1;